export const mediaContent = {
  featured: [
    {
      index: 0,
      title: "Tim Gillen Explains the Signal Messaging App",
      date: "April 1, 2025",
      source: "9&10 News",
      description: "Tim Gillen explains the Signal messaging app. What is it, is it secure, and how does it work?",
      thumbnailUrl: "/assets/media/signal-tim-gillen.png",
      videoUrl: "https://www.9and10news.com/2025/04/01/good-day-northern-michigan-tuesday-april-1/",
      type: "tv"
    },
    {
      index: 1,
      title: "Tim Gillen on the Impact of New AI Assistant Technology",
      date: "December 17, 2024",
      source: "9&10 News",
      description: "Tim discusses the latest developments in AI technology and its potential impact on local businesses. Find Tim's segment in the Good Day Northern Michigan episode by scrolling down to 'Tim Gillen on the impact of new AI assistant technology'.",
      thumbnailUrl: "/assets/media/ai-segment-thumbnail.jpg",
      videoUrl: "https://www.9and10news.com/2024/12/17/good-day-northern-michigan-tuesday-dec-17/",
      type: "tv"
    },
    {
      index: 2,
      title: "Hot Tech Gadgets For Christmas 2024",
      date: "December 3, 2024",
      source: "9&10 News",
      description: "Tim shares his expert recommendations for the hottest tech gadgets ahead of the holiday season. Find Tim's segment in the Good Day Northern Michigan episode by scrolling down to 'Tim Gillen on the hottest tech gadgets ahead of the holidays'.",
      thumbnailUrl: "/assets/media/hot-tech-gadgets.png",
      videoUrl: "https://www.9and10news.com/2024/11/05/good-day-northern-michigan-tuesday-nov-5/#:~:text=Tech%20expert%20Tim%20Gillen%20on%20steps%20to%20protect%20your%20cyber%20safety",
      type: "tv"
    },
    {
      index: 3,
      title: "3 Tips Anyone Can Use for Cyber Security",
      date: "November 7, 2024",
      source: "9&10 News",
      description: "Tim shares essential cybersecurity practices that every small business should implement to protect their digital assets.",
      thumbnailUrl: "/assets/media/cybersecurity-segment.jpg",
      videoUrl: "https://www.9and10news.com/2024/11/05/good-day-northern-michigan-tuesday-nov-5/#:~:text=Tech%20expert%20Tim%20Gillen%20on%20steps%20to%20protect%20your%20cyber%20safety",
      type: "tv"
    },
    {
      index: 4,
      title: "Passkeys, Passwords- what's the difference?",
      date: "August 6, 2024",
      source: "9&10 News",
      description: "Talking Tech – Google – with Tim Gillen of Terrapin Networks.",
      thumbnailUrl: "/assets/media/password-segment.jpg",
      videoUrl: "https://www.9and10news.com/2024/08/06/good-day-northern-michigan-tuesday-aug-6/#:~:text=Bay%20Humane%20Society-,Talking%20Tech%20%2D%20Google%20%2D%20with%20Tim%20Gillen%20of%20Terrapin%20Networks,-In%20this%20article",
      type: "tv"
    },
    {
      index: 5,
      title: "AT&T's Data Leak- What It Means For You",
      date: "July 16, 2024",
      source: "9&10 News",
      description: "The AT&T data leak is the focus of our Tech Tuesday talk with our favorite expert, Tim Gillen of Terrapin Networks in Traverse City. Tim give us his reaction and tells us what we need to know.",
      thumbnailUrl: "/assets/media/data-leak.jpg",
      videoUrl: "https://www.9and10news.com/2024/07/16/good-day-northern-michigan-tuesday-july-16/#:~:text=is%20the%20focus%20of%20our%20Tech%20Tuesday",
      type: "tv"
    },
    {
      index: 6,
      title: "Why Are There So Many Cyber Attacks Lately?",
      date: "July 6, 2024",
      source: "9&10 News",
      description: "In the last few months, there has been a big uptick in cyber attacks. The Big Three Auto Dealers' software CDK was compromised, as well as Traverse City Area Public Schools, Michigan area hospitals, and Grand Traverse County. Yet, in the recent budget from Grand Traverse County, there was no money set aside for dealing with these attacks. Why?",
      thumbnailUrl: "/assets/media/cyber-attacks.jpg",
      videoUrl: "https://www.9and10news.com/2024/07/02/good-day-northern-michigan-tuesday-july-2/#:~:text=Cyber%20attacks%20%2D%20Tim%20from%20Terrapin%20Networks",
      type: "tv"
    }
  ],
  radio: [
    {
      title: "The Terrapin Small Biz Connection",
      date: "2018-2020",
      source: "WTCM Radio",
      description: "Tim and his daughter Ruthy hosted this radio show and podcast, discussing current tech events, cybersecurity, and interviewing small business leaders in northern Michigan.",
      type: "radio"
    }
  ],
  articles: [
    {
      title: "Protecting Your Small Business from Cyber Threats",
      date: "February 2024",
      source: "Northern Express",
      description: "Tim shares essential cybersecurity tips that every small business owner should know.",
      type: "article"
    }
  ]
}; 